import { BaseService } from "@js/filesfromccqbase/BaseService";
import { BroadcastService } from "@js/filesfromccqbase/BroadcastService";
import { RoleService } from "./RoleService";
import { UserService } from "./UserService";
import { ApplicationUserCrudClient, Case, CaseClient, CaseStatusEnum, DevelopmentInput } from "@src/apis/ModularClient";
import { NewBlankCaseDTO } from "@js/DTO/NewBlankCaseDTO.cs";
import { DevelopmentInputService } from "./DevelopmentInputService";
import { IndexService } from "@js/services/IndexService";
import { ODataHelper } from "@js/helpers/ODataHelper";

export class CaseService extends BaseService<Case, number> {
  currentLender;
  tubeMapStatus: number;
  isProceed: boolean;
  task: string;
  IsSupplimentInfoFilled: boolean;

  static $inject = [
    "$http",
    "$cookies",
    "$rootScope",
    "$q",
    "$timeout",
    "BroadcastService",
    "UserService",
    "RoleService",
    "DevelopmentInputService",
    "CaseClient",
    "IndexService",
    "ApplicationUserCrudClient",
    "ODataHelper",
  ];

  constructor(
    http: ng.IHttpService,
    cookies: ng.cookies.ICookiesService,
    private rootScope: ng.IRootScopeService,
    q: ng.IQService,
    timeout: ng.ITimeoutService,
    broadcastservice: BroadcastService,
    private $user: UserService,
    private $roleService: RoleService,
    private $DevelopmentInputservice: DevelopmentInputService,
    private caseClient: CaseClient,
    private indexService: IndexService,
    private applicationUserCrudClient: ApplicationUserCrudClient,
    private odataHelper: ODataHelper,
  ) {
    super(http, cookies, rootScope, q, timeout, broadcastservice);
    this.$baseAddress = "/api/case";
    this.$broadcastBusinessNameSingular = "case";
    this.$broadcastBusinessNamePlural = this.$broadcastBusinessNameSingular + "s";
    this.$broadcastScreen = this.$broadcastBusinessNamePlural;
  }

  public updateCaseState(caseId: number, caseStatus: CaseStatusEnum): void {
    const caseStatusString: string = Object.keys(CaseStatusEnum).find((key) => CaseStatusEnum[key] === caseStatus);
    if (!(this.rootScope as any).caseStateChange) {
      (this.rootScope as any).caseStateChange = {};
    }
    (this.rootScope as any).caseStateChange[caseId] = caseStatusString;
    this.rootScope.$broadcast("caseStateChange", {
      id: caseId,
      status: caseStatusString,
    });
  }

  async newBlankCase(isPrimaryApplicant: boolean): Promise<NewBlankCaseDTO> {
    let defer = this.$q.defer<NewBlankCaseDTO>();
    var currentdate = new Date();

    var SearchName =
      "My Loan Search " + currentdate.getDate() + "/" + (currentdate.getMonth() + 1) + "/" + currentdate.getFullYear();

    let newDTO = {} as DevelopmentInput;
    newDTO.ownerUser = await this.indexService.currentUser.then((user) => user.userName);
    newDTO.userId = await this.indexService.currentUser.then((user) => user.id);
    newDTO.saveQueryAndResults = true;
    newDTO.searchName = SearchName;
    newDTO.cI_Dev_Contingency = 0.05;
    newDTO.cI_Dev_BuildTerm = 12;
    newDTO.cI_Dev_LoanTermReq = 18;
    newDTO.cI_Dev_DateOfOrigPurch = new Date();

    // lookup the broker info for the current user and Set the broker info on to the search
    const organisationId = await this.$user.getBrokerOrganisationId();
    if (organisationId != null) {
      newDTO.brokerOrganisationId = organisationId;

      const isBroker = await this.$roleService.isBroker();
      if (!isBroker) {
        this.odataHelper
          .getOne(this.applicationUserCrudClient, {
            filter: {
              and: [{ organisationId: { eq: organisationId } }, { isOrganisationAdmin: { eq: true } }],
            },
          })
          .then((res) => {
            newDTO.brokerUserId = res?.id;
          });
      } else {
        newDTO.brokerUserId = await this.indexService.currentUser.then((user) => user.id);
      }
    }

    this.$DevelopmentInputservice.saveSearch(newDTO).then((response) => {
      let newBlankCaseDTO = {} as NewBlankCaseDTO;
      newBlankCaseDTO.NewSearchId = response;

      newDTO.id = response;
      this.caseClient
        .promoteSearchToCase(newDTO.id, null, null, isPrimaryApplicant)
        .then((newCaseId: number) => {
          newBlankCaseDTO.NewSearchId = response;
          newBlankCaseDTO.NewCaseId = newCaseId;

          defer.resolve(newBlankCaseDTO);
        })
        .catch((response) => {
          defer.reject(newBlankCaseDTO);
        });
    });

    return defer.promise;
  }

  public onStateChange(caseId, callback: (caseStatus: string) => void): void {
    this.rootScope.$on("caseStateChange", function (event, statusUpdate: { id: number; status: string }) {
      if (statusUpdate.id === caseId) {
        callback(statusUpdate.status);
      }
    });
  }

  updateTubeMap(caseStatus) {
    switch (caseStatus) {
      case CaseStatusEnum.Search:
        this.tubeMapStatus = 0;
        break;
      case CaseStatusEnum.NewCase:
        this.tubeMapStatus = 2;
        break;
      case CaseStatusEnum.InProgress:
        this.tubeMapStatus = 2;
        break;
      case CaseStatusEnum.UnderReview:
        this.tubeMapStatus = 2;
        break;
      case CaseStatusEnum.ReadyToSubmit:
        this.tubeMapStatus = 3;
        break;
      case CaseStatusEnum.SubmittedToLendersPendingReview:
        this.tubeMapStatus = 2;
        break;
      case CaseStatusEnum.SubmittedToLendersForHoT:
        this.tubeMapStatus = 4;
        break;
      case CaseStatusEnum.Applied:
        this.tubeMapStatus = 4;
        break;
      case CaseStatusEnum.CreditApproved:
        this.tubeMapStatus = 5;
        break;
      case CaseStatusEnum.WithProfessionals:
        this.tubeMapStatus = 6;
        break;
      case CaseStatusEnum.Completed:
        this.tubeMapStatus = 7;
        break;
      case CaseStatusEnum.Dormant:
        this.tubeMapStatus = 7;
        break;
      default:
        this.tubeMapStatus = 1;
    }
  }

  getTubeMap(): number {
    return this.tubeMapStatus;
  }

  getIsProceed() {
    return this.isProceed;
  }

  setIsProceed(isProceed) {
    this.isProceed = isProceed;
  }

  getLenderTask() {
    return this.task;
  }

  setLenderTask(task) {
    this.task = task;
  }

  getIsSupplimentInfoFilled() {
    return this.IsSupplimentInfoFilled;
  }

  setIsSupplimentInfoFilled(IsSupplimentInfoFilled) {
    this.IsSupplimentInfoFilled = IsSupplimentInfoFilled;
  }
}
